<template>
  <a class="category-link quick-menu-link scrollactive-item" :href="`#${href}`" :rel="href">
    <slot></slot>
    <span class="iw-body-text-large">{{ category }}</span>
  </a>
</template>

<script>
import { removeSpecialCharaters } from "./../../../../../utils";

export default {
  name: "CategoryLink",
  props: {
    category: String
  },
  computed: {
    href: function() {
      return removeSpecialCharaters(this.category).toLowerCase();
    }
  }
};
</script>
